import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Select from "react-select";
import * as moment from 'moment';
import * as service from '../../../services/service';

function ItemDistribution() {
    const [data, setData] = useState([]);
    const [userId, setUserId] = useState('');
    const [userData, setUserData] = useState([]);
    const [officeId, setOfficeId] = useState('');
    const [officeData, setOfficeData] = useState([]);
    const [error, setError] = useState(null);
    const [dataError, setDataError] = useState(null);
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const navigate = useNavigate();

    const getUsers = () => {
        fetch(
            service.USERS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.userId, label: item.userName }));
                setUserData(data2);
            });
    };

    const getOffices = () => {
        fetch(
            service.OFFICE_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.officeId, label: item.officeName }));
                setOfficeData(data2);
            });
    };

    const validate = () => {
        let isValid = true;
        if (!userId && !officeId) {
            isValid = false;
            setError("Please select user or select office to get the details");
        }
        else {
            setError('');
        }
        return isValid;
    }
    const getDetails = () => {
        setLoading(true);
        if (validate()) {
            fetch(
                service.ITEM_DISTRIBUTION_SEARCH_URL,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        UserId: userId.value,
                        OfficeId: officeId.value,
                        ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                    })
                })
                .then(res => res.json())
                .then(result => {                    
                    if (result[0].message.messageType === "Failed") {
                        setDataError(result[0].message.message);
                        setData([]);
                    }
                    else {
                        setData(result);
                        setDataError('');
                    }
                })
                .catch(err => {
                    if (err) {
                        setDataError(err);
                    };
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        getUsers();
        getOffices();
        setLoading(false);
    }, []);

    const userChangeHandler = (ev) => {
        setUserId(ev);
    }
    const officeChangeHandler = (ev) => {
        setOfficeId(ev);
    }
    const addNew = () => {
        navigate('/addedititemdistribution/0');
    };
    const handleEdit = (id) => {
        navigate(`/addedititemdistribution/${id}`);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ float: 'right' }}>
                <MDButton color="info" onClick={addNew}>
                    ADD NEW
                </MDButton>
            </div>
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Item Ditribution Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <MDBox mx={2}
                                mt={-3}
                                py={3}
                                px={2}>
                                <Stack direction="row" spacing={5} width={5000}>
                                    <div style={{ fontSize: '12px' }}>
                                        <Select
                                            options={userData}
                                            name="user"
                                            value={userId}
                                            onChange={userChangeHandler}
                                            isSearchable
                                            styles={selectStyles}
                                            placeholder="Select User"
                                        />
                                    </div> 
                                    <div style={{ fontSize: '12px', fontWeight: 'bold' }}>OR</div>
                                    <div style={{ fontSize: '12px' }}>
                                        <Select
                                            options={officeData}
                                            name="office"
                                            value={officeId}
                                            onChange={officeChangeHandler}
                                            isSearchable
                                            styles={selectStyles}
                                            placeholder="Select Office"
                                        />
                                    </div>
                                    <div style={{ fontSize: '12px', color: 'red' }}>{error}</div>
                                    <MDButton color="info" onClick={getDetails} endIcon={<SearchIcon />}>
                                        Search
                                    </MDButton>
									<div style={{ fontSize: '12px', fontWeight: 'bold', color: 'red' }}>Kindly distribute the items either to a User OR to an office at a time.</div>
                                </Stack>
                                <div style={{ fontSize: '12px', color: 'red' }}>{error}</div>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <div style={{ fontSize: '12px', color: 'red' }}>{dataError}</div>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                        <Table aria-label="simple table">
                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item Category</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Unit</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>User</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Office</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Name</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Distribution Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Edit</TableCell>
                                            </TableRow>

                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.distributionId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell style={{ fontSize: '14px' }}>{row.itemCategory}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.item}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.quantity}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.unit}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.userName}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.officeName}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.officerName}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{moment(row.distributionDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleEdit(row.distributionId)}>Edit</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default ItemDistribution;